import throttle from '@/utils/throttle'
import { getScrollEventTarget, getScrollTop } from '@/utils/scroll'
import { cssSupported, setStyle } from '@/utils/css'

const ctx = '@@sticky'

function doCheck() {
  const { scrollEventTarget } = this
  const element = this.el
  const { elementTop } = this
  const viewportScrollTop = getScrollTop(scrollEventTarget)
  const { nextSibling } = element
  const marginTop = element.clientHeight + parseFloat(this.nextSiblingMarginTop)

  if (viewportScrollTop >= elementTop) {
    element.style.position = 'fixed'
    nextSibling.style.marginTop = `${marginTop}px`
  } else {
    nextSibling.style.marginTop = this.nextSiblingMarginTop
    element.style.position = 'static'
  }
}

function doBind() {
  if (this.binded) return
  this.binded = true

  const directive = this
  const element = directive.el

  directive.elementTop = element.offsetTop
  directive.scrollEventTarget = getScrollEventTarget(element)
  directive.scrollListener = throttle(doCheck.bind(directive), 50)
  directive.scrollEventTarget.addEventListener('scroll', directive.scrollListener)
}

export default {
  bind(el, binding, vnode) {
    const vm = vnode.context
    const expression = binding.value || {}

    if (expression.disabled) {
      return
    }

    vm.$on('hook:mounted', () => {
      el[ctx] = {
        el,
        vm,
        expression,
        nextSibling: el.nextSibling,
        nextSiblingMarginTop: window.getComputedStyle(el.nextSibling).marginTop,
      }

      const isSupportSticky = cssSupported('position', 'sticky')
      const top = expression.top || '0px'
      const zIndex = expression.zIndex || '1000'

      setStyle(el, {
        top,
        zIndex,
      })

      if (!el.style.width) {
        el.style.width = '100%'
      }

      if (isSupportSticky) {
        el.style.position = 'sticky'
      } else {
        el.style.position = 'static'
        doBind.call(el[ctx])
      }
    })
  },

  unbind(el) {
    if (el[ctx] && el[ctx].scrollEventTarget) {
      el[ctx].scrollEventTarget.removeEventListener('scroll', el[ctx].scrollListener)
    }
  },
}
